<template>
<v-container class="mt-8">

  <!-- contenedor para ocultar plantilla pdf
  -->
  <div style="display: none;">
    <div ref="plantillaPDF" class="contenedor-pdf">

      <!-- contenido -->
      <div class="contenedor-contenido">

        <!-- titulo -->
        <div style="position: relative; display: flex; justify-content: center; align-items: center;">
          <span class="texto-titulo">constancia de estuios</span>
          <img src="logo-constancia.webp" alt="logo" class="logo-documento">
        </div>

        <!-- contenido -->
        <div style="
        display: flex;
        flex-direction: column;
        margin: 1rem; margin-top: 96px;">

          <span class="texto"><b>A quien corresponda.-</b></span>

          <span class="texto">
            Por medio de la presente <b>Instituto Neurolingüística Bilingüe (INBI)</b>, hace de su conocimineto
            que el alumno <b>{{ nombreAlumno }}</b>, forma parte del alumnado de esta institución con matricula <b>{{ matriculaAlumno }}</b>
            , quien cursara el nivel {{ nivel }} de los {{ esGrupoTeens ? '16' : '14' }} niveles correspondientes al curso {{ esGrupoTeens ? 'TEENS' : 'ADULTS' }}, en el horario: {{ horario }}, en la sucursal
            {{ sucursal }}, {{ direccion_plantel }}</span>

          <span class="texto">Documento valido de: <b>{{ inicioClases }}</b> a <b>{{ finClases }}</b></span>

          <span class="texto">A petición de la parte interesada y para los usos y fines que convengan, se
            extiende la presente en el municipio de {{ municipio }}, a {{ diaHoy }} días del mes de {{ mesActual }} de {{ anioActual }}.
          </span>

          <span class="texto" style="text-align: center;">Quedo a sus órdenes para cualquier aclaración en caso
            de ser necesaria.
          </span>
          <!-- firma -->
          <div style="display: flex; flex-direction: column;
          justify-content: center; align-items: center; padding-top: 4rem;">
            <!-- <img src="../../assets/constancia-estudios.png" alt="" style="width: 250px; height: 250px;"> -->
            <!-- <img src="../../assets/constancia-estudios.png" alt="" style="width: 250px; height: 250px; transform: rotate(12deg); margin-left: 270px;"> -->
            <!-- <img src="../../assets/constancia-estudios.png" alt="" style="width: 250px; height: 250px; transform: rotate(-12deg); margin-right: 350px;"> -->

          </div>
        </div>

      </div>

      <!-- colores laterales -->
      <div class="barra-lateral"></div>

      <!-- colores laterales -->
      <div class="barra-lateral-secundaria"></div>

      <!-- colores laterales -->
      <div class="barra-lateral-oscura"></div>

      <!-- iconos bottom -->
      <div class="contenedor-iconos">
        <!-- aux para posición y formatear textos -->
        <div style="position: relative; width: 100%; text-wrap-mode: nowrap;">
          <div class="sub-contenedor-iconos">

            <!-- ubicacion -->
            <div style="display: flex; align-items: center;">
              <div class="fix-iconos-svg">
                <svg
                class="iconos"
                version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="512" height="512"
                viewBox="0 0 512 512"
                >
                  <g transform="translate(0,512) scale(0.1,-0.1)"
                  fill="currentColor" stroke="none">
                    <path d="M2289 4785 c-497 -81 -927 -353 -1202 -763 -118 -176 -217 -409 -258
                    -611 -29 -139 -36 -437 -15 -596 20 -151 36 -212 93 -355 181 -456 527 -993
                    1078 -1675 213 -264 351 -407 432 -446 65 -32 196 -33 263 -3 59 28 149 103
                    208 174 26 32 86 102 133 157 420 482 845 1098 1048 1518 108 223 192 468 228
                    665 24 135 24 401 -1 535 -39 209 -140 454 -263 637 -258 384 -653 648 -1118
                    748 -130 28 -492 37 -626 15z m466 -976 c290 -70 519 -305 580 -597 8 -37 15
                    -114 15 -172 0 -215 -64 -384 -204 -536 -153 -168 -352 -255 -586 -255 -373 0
                    -678 237 -771 599 -26 103 -26 281 0 384 110 431 532 683 966 577z"/>
                  </g>
                </svg>
              </div>
              <div>
                <p class="iconos-texto" style="padding-top: 10px;">
                  José Santos Chocano #111, Anáhuac
                </p>
                <p class="iconos-texto">
                  San Nicolás de los Garza, N.L. 66450
                </p>
              </div>
            </div>
            <!-- telefono -->
            <div style="display: flex; align-items: center;">
              <div class="fix-iconos-svg">
                <svg class="iconos"
                version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="512" height="512" viewBox="0 0 512 512"
                >
                <g transform="translate(0,512) scale(0.1,-0.1)"
                fill="currentColor" stroke="none">
                <path d="M922 4461 c-29 -11 -67 -29 -86 -40 -53 -33 -130 -121 -162 -186
                l-29 -60 1 -230 c1 -183 5 -259 23 -375 95 -624 329 -1166 712 -1650 106 -135
                404 -433 539 -539 484 -383 1026 -617 1650 -712 116 -18 192 -22 375 -23 l230
                -1 67 34 c82 41 163 123 204 206 l29 60 0 295 0 295 -28 59 c-36 78 -88 140
                -151 181 -28 18 -166 80 -306 137 l-255 103 -115 0 c-109 0 -119 -2 -183 -32
                -86 -41 -171 -125 -211 -210 l-29 -61 -71 20 c-312 85 -646 281 -880 514 -232
                232 -427 566 -514 880 l-20 71 61 29 c85 40 169 125 210 211 30 65 32 74 32
                183 l0 115 -104 255 c-56 140 -118 278 -136 306 -41 63 -103 115 -181 151
                l-59 28 -280 2 c-255 3 -285 1 -333 -16z"/>
                </g>
                </svg>
              </div>
              <div>
                <p class="iconos-texto" style="margin-top: 10px;">
                  (81) 2473 5131
                </p>
              </div>
            </div>
            <!-- web -->
            <div style="display: flex; margin-top: 6px; align-items: center;">
              <div class="fix-iconos-svg">
                <svg class="iconos"
                version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="512" height="512" viewBox="0 0 512 512">
                  <g transform="translate(0, 512) scale(.1, -.1)"
                  fill="currentColor" stroke="none">
                    <path d="M2350 4850 c-460 -44 -927 -239 -1269 -529 -46 -39 -87 -71 -91 -71
              -5 0 -66 -66 -135 -147 -324 -377 -498 -749 -571 -1223 -25 -159 -25 -481 0
              -640 65 -428 225 -797 484 -1120 364 -453 878 -745 1472 -836 138 -22 482 -24
              605 -5 174 27 297 55 442 103 679 222 1229 772 1451 1451 86 262 116 450 116
              727 0 206 -9 295 -45 470 -179 872 -858 1567 -1729 1769 -212 49 -523 70 -730
              51z m312 -351 c97 -49 210 -195 298 -383 51 -109 108 -262 100 -269 -11 -11
              -206 -38 -347 -49 -116 -9 -190 -9 -305 0 -142 11 -337 38 -348 49 -17 16 120
              328 192 439 139 214 273 283 410 213z m-783 -203 c-36 -73 -83 -182 -104 -242
              -21 -60 -39 -110 -40 -112 -7 -9 -228 90 -334 151 l-43 25 73 52 c114 79 242
              149 379 207 69 29 127 53 130 53 3 0 -24 -60 -61 -134z m1507 49 c93 -43 199
              -104 298 -173 l78 -55 -78 -43 c-75 -42 -236 -115 -279 -128 -18 -5 -24 7 -58
              104 -22 61 -69 170 -105 244 l-67 134 70 -25 c38 -14 102 -40 141 -58z m-2202
              -509 c102 -62 276 -148 379 -187 79 -29 88 -35 83 -54 -35 -138 -83 -505 -91
              -700 -4 -71 -8 -140 -11 -152 l-4 -23 -470 0 c-441 0 -470 1 -470 18 0 46 33
              229 60 328 55 208 143 402 265 584 62 92 170 230 181 230 3 0 38 -20 78 -44z
              m2896 -31 c236 -288 395 -663 435 -1022 l7 -63 -471 0 -471 0 -4 23 c-3 12 -8
              82 -11 156 -7 161 -36 399 -69 582 -14 73 -24 134 -23 134 1 1 40 17 87 35
              104 41 292 134 380 189 36 22 68 40 72 41 4 0 34 -34 68 -75z m-1975 -305
              c284 -49 626 -48 915 1 67 11 126 17 130 12 8 -9 31 -134 54 -298 13 -88 28
              -262 39 -437 l4 -58 -687 0 -687 0 4 58 c17 288 61 650 88 730 6 15 2 16 140
              -8z m-561 -1122 c3 -13 7 -81 11 -153 8 -194 56 -557 91 -699 4 -18 -6 -25
              -83 -55 -107 -41 -280 -127 -381 -188 -88 -53 -76 -59 -188 89 -150 200 -266
              433 -329 665 -30 107 -65 296 -65 347 0 15 43 16 470 16 l470 0 4 -22z m1701
              -5 c-2 -16 -7 -82 -10 -148 -10 -191 -65 -597 -85 -618 -4 -5 -63 1 -130 12
              -68 12 -199 26 -291 33 -197 13 -430 1 -629 -33 -67 -11 -126 -17 -130 -12 -8
              9 -31 134 -54 298 -13 88 -28 262 -39 438 l-4 57 688 0 689 0 -5 -27z m1270
              -35 c-40 -369 -219 -781 -458 -1052 l-43 -49 -75 45 c-99 60 -272 146 -379
              188 -47 18 -86 34 -87 35 -1 0 9 61 23 134 33 183 62 421 69 582 3 74 8 144
              11 157 l4 22 471 0 471 0 -7 -62z m-1765 -1018 c116 -10 301 -38 310 -47 8 -7
              -49 -160 -100 -269 -89 -190 -200 -333 -300 -385 -61 -31 -139 -31 -200 0
              -100 52 -211 195 -300 385 -51 109 -108 262 -100 269 8 8 194 37 292 46 135
              12 267 12 398 1z m-977 -250 c22 -61 69 -170 105 -244 77 -152 83 -146 -78
              -79 -120 50 -262 128 -369 203 l-73 52 53 31 c30 17 95 49 144 72 50 23 106
              49 125 58 19 8 40 16 45 16 6 1 27 -49 48 -109z m1726 65 c58 -25 142 -65 185
              -89 l79 -43 -74 -52 c-114 -80 -257 -158 -390 -212 -66 -27 -121 -49 -122 -49
                    -1 0 28 61 64 135 37 74 84 184 106 245 21 60 40 110 42 110 2 0 51 -20 110 -45z"/>
                  </g>
                </svg>
              </div>
              <div>
                <p class="iconos-texto">https://www.inbi.mx</p>
              </div>

            </div>

          </div>
        </div>

      </div>
      <div class="bot">
        <qrcode-vue
            :value="qr"
            :size="100"
            level="M"
            :background="'#f9f9f9'"
            :foreground="'#555555'"
          />
      </div>

    </div>
  </div>

  <v-row>
  <!-- Título de la sección -->
  <v-col cols="12" class="pb-4">
    <v-card class="mx-auto transparent elevation-0">
      <v-card-text class="pb-0">
        <div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
          Constancias de estudio
        </div>
      </v-card-text>
    </v-card>
  </v-col>

  <v-col cols="12">
    <v-alert
      v-if="mostrarAdvertencia"
      type="warning"
      dismissible
      @input="mostrarAdvertencia = false"
      >
      Ya tienes una constancia de este ciclo.
    </v-alert>
  </v-col>

  <!-- Tabla de constancias -->
  <v-col cols="12">
    <v-card class="shadowCard">
      <v-card-title primary-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="descargarPDFConstancia()" small rounded>
          Generar nueva constancia
        </v-btn>
      </v-card-title>

      <v-card-text>
        <!-- Filtro de búsqueda -->
        <v-row justify="end" class="mb-3">
          <v-col cols="12" md="6" lg="4">
            <v-text-field
              v-model="search"
              label="Buscar"
              filled
              dense
              hide-details
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- Tabla con solo la columna 'Registrada' -->
        <v-data-table
          :headers="[
            { text: 'Registrada', value: 'fecha_alta', align: 'start' },
            { text: 'Ciclo', value: 'ciclo', sortable: false, align: 'center' },
            { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
          ]"
          :items="constancias"
          class="elevation-0"
          :search="search"
          hide-default-footer
          dense
        >
          <!-- Columna de acciones -->
          <template v-slot:item.actions="{ item }">
            <v-btn color="blue" dark small @click="descargarPDFConstancia(item)">
              Descargar
            </v-btn>
          </template>

          <!-- No hay datos -->
          <template v-slot:no-data>
            <v-btn color="primary" @click="inicializar" small>
              Actualizar
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-col>

</v-row>
<v-speed-dial top fixed>
    <template v-slot:activator>
        <v-btn color="white" dark fab :to="{name: 'Perfil'}">
            <v-icon color="primary">
                mdi-keyboard-backspace
            </v-icon>
        </v-btn>
    </template>
</v-speed-dial>

 <v-overlay :value="generandopdf">
  <v-card class="pa-4 text-center">
    <v-progress-circular indeterminate color="primary" size="40"></v-progress-circular>
    <div class="mt-3 font-weight-medium">
      Generando constancia de estudios<span class="dots"></span>
    </div>
  </v-card>
</v-overlay>


    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <Loader v-if="cargar" :loader="loader" />


  </v-container>
</template>

<script>

// importar librerías
import {
    mapGetters
} from 'vuex'

// Componentes
import Alerta from '@/components/alertas/Alerta.vue'
import Loader from '@/components/alertas/Loader.vue'
import html2pdf from "html2pdf.js";
import QrcodeVue from 'qrcode.vue'
import { RouterLink } from 'vue-router'

export default {


  components: {
    Alerta,
    Loader,
    QrcodeVue,
  },

  data: () => ({
    //Alertas
    respuestaAlerta: false,
    loader: true,
    cargar: false,
    mostrarAdvertencia: false,

    parametros: {
      dialogError: false,
      mensaje: '',
      color: ''
    },

    dialog: false,
    dialogDelete: false,
    dialogErrorConstancia: false,

    nombreAlumno: '',
    matriculaAlumno: '',
    nivel: '',
    horario: '',
    sucursal: '',
    direccion_plantel: '',
    inicioClases: '',
    finClases: '',
    municipio: '',
    mesActual: '',
    anioActual: '',
    ciclo: '',
    diaHoy: '',
    esGrupoTeens: false,
    qr: '',

    constancias: [],
    search: '',

    generandopdf: false,
    url: ''

  }),

  computed:{
    	...mapGetters( 'login', [
        'getUsuarioLMS',
        'getDatosUsuarioLMS',
        'getGrupos',
        'getEscuela'
      ]),

  },

  async created() {

    const urlUnidadNegocio = process.env.UNIDAD_NEGOCIO === 2
    ? process.env.VUE_APP_RUTA_API_FAST : process.env.VUE_APP_RUTA_API_INBI

    this.url   =  process.env.NODE_ENV == 'development' ?
    'http://localhost:3001/constancias-estudios/' :

    urlUnidadNegocio + 'constancias-estudios/'

    const index = this.getGrupos.length - 1

    this.esGrupoTeens = this.getGrupos[index].curso.includes('een')


    this.nombreAlumno = this.getUsuarioLMS.nombre_completo
    this.matriculaAlumno = this.getUsuarioLMS.usuario
    this.horario = `${ this.getGrupos[index].hora_inicio } - ${ this.getGrupos[index].hora_fin }`

    const fecha = new Date();
    const meses = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];

    this.mesActual = meses[fecha.getMonth()]; // getMonth() devuelve 0-11
    this.anioActual = fecha.getFullYear();

    this.nivel = this.getGrupos[index].id_nivel

    this.municipio = this.getDatosUsuarioLMS.municipio

    await this.inicializar()
  },

  methods: {

    async inicializar(){
      try {
      const constanciasRes = await this.$http.get(`usuario.get.constancias/${this.getUsuarioLMS.iderp}`);
      this.constancias = constanciasRes.data ? constanciasRes.data : [];
      //console.log( this.constancias )
      this.cargar = false;
    } catch (error) {
      this.validarError(error.response.data.message);
      this.cargar = false;
    }

    },

    async descargarPDFConstancia(constancia) {
      try {

        let descargarPDF = true;

        // Carga de datos

        if (constancia) {

          // TODO descargar el archivo
          window.location = this.url + constancia.archivo
          return

        }

        console.log('generar nueva constancia')
        // Traemos la información necesaria para la constancia
        const response = await this.$http.get(`usuario.informacion.constancia/${this.getUsuarioLMS.iderp}`);

        if (response.data) {
          //console.log( response.data )
          this.ciclo = response.data.ciclo;
          this.direccion_plantel = response.data.plantel.includes("ONLINE")
          ? " en modalidad remota."
          : " ubicado en " + response.data.direccion + ".";
          this.inicioClases = this.formatearFechaTexto(response.data.fecha_inicio_ciclo);
          this.finClases = this.formatearFechaTexto(response.data.fecha_fin_ciclo);
          this.sucursal = response.data.plantel;
          this.diaHoy = new Date().getDate();
        }

        //console.log('se recupero la información')

        // Hay que generar el archivo
        if (!descargarPDF) return;

        this.generandopdf = true;

        const formData = new FormData();

        // Agregar los campos del payload
        formData.append("id_usuario", this.getUsuarioLMS.iderp);
        formData.append("sucursal", this.sucursal);
        formData.append("direccion_plantel", this.direccion_plantel);
        formData.append("inicioClases", this.parseFechaES(this.inicioClases));
        formData.append("ciclo", this.ciclo);

        // await this.addConstanciaEstudios().catch(() => (descargarPDF = false));

        await this.$http.post(`usuario.add.constancia`, formData )
        .then(async response => {
          if( response.body.id ) this.qr = JSON.stringify( response.body.id )
        })
        .catch(error => {
          this.cargar = false;
          this.mostrarAdvertencia = true;
          throw new error()
        })


        // Asegura render completo antes de capturar
        await this.$nextTick();
        await new Promise((r) => setTimeout(r, 600));

        const element = this.$refs.plantillaPDF;
        if (!element) {
          this.generandopdf = false;
          return;
        }

        // Opciones de PDF
        const opciones = {
          margin: 0,
          filename: `constancia-${this.matriculaAlumno}-${this.ciclo.toLowerCase().replace(/\s|_/g, "-")}.pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true, logging: false },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        };

        // Genera el PDF en memoria (Blob)
        const pdfBlob = await html2pdf().set(opciones).from(element).outputPdf("blob");

        // Enviar el PDF al servidor con Axios

        formData.append("file", pdfBlob, opciones.filename);
        formData.append("id", this.qr);

        await this.$http.post(`usuario.add.constancia`, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        } )
        .then(async response => {

          //console.log( response.body )
          window.location = this.url + response.body.archivo
          this.cargar = false;
          await this.inicializar()
        })
        .catch(error => {
          console.log( error )
          this.cargar = false;
          this.mostrarAdvertencia = true;
          throw new error()
        })


        this.generandopdf = false;

      } catch (error) {
        console.log( error)
        console.error("Error al generar el PDF:", error);
        this.generandopdf = false;
        this.$toast?.error("No se pudo generar el PDF");
      }
    },

    parseFechaES(fechaStr) {
      // mapa de meses en español a número
      const meses = {
        'enero': '01',
        'febrero': '02',
        'marzo': '03',
        'abril': '04',
        'mayo': '05',
        'junio': '06',
        'julio': '07',
        'agosto': '08',
        'septiembre': '09',
        'octubre': '10',
        'noviembre': '11',
        'diciembre': '12'
      };

      // separar día, mes y año
      const partes = fechaStr.split(' '); // ["08", "de", "septiembre", "de", "2025"]
      const dia = partes[0];
      const mes = meses[partes[2].toLowerCase()];
      const anio = partes[4];

      return `${anio}-${mes}-${dia}`;
    },

    formatearFechaTexto(fechaNumero) {

      const fecha = new Date( fechaNumero );
      return new Intl.DateTimeFormat('es-ES', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        timeZone: 'UTC'
      }).format(fecha);

    }

  }
}

</script>

<style scoped>

.contenedor-pdf {
  width: 794px;
  height: 1122px;
  background-color: white;
  position: relative;
  display: flex;
  flex-direction: column;
  font-family: Arial, Helvetica, sans-serif;
}

.barra-lateral-oscura {
  height: 100%;
  width: 16px;
  background-color: #333;
  position: absolute;
}

.barra-lateral {
  height: 100%;
  width: 57px;
  background-color: #1681A3;
  position: absolute;
}

.barra-lateral-secundaria {
  height: 100%;
  width: 40px;
  background-color: #46cfff;
  position: absolute;
}

.contenedor-iconos {
  height: 168px;
  width: 50px;
  margin-left: 40px;
  margin-bottom: 50px;
  bottom: 0;
  background-color: #46cfff;
  position: absolute;
  border-top-right-radius: 90%;
  border-bottom-right-radius: 90%;
}

.bot {
  height: 218px;
  width: 100%;
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 50px;
  bottom: 0;
  position: absolute;
  display: flex;
  justify-content: end;
  overflow: hidden;
}

.sub-contenedor-iconos {
  position: absolute;
  left: 0%;
  display: flex;
  flex-direction: column;
  font-weight: bold;
  height: 140px;
  justify-content: space-around;
}

.fix-iconos-svg {
  display: flex;
  padding: 2px;
  margin-right: 24px;
  margin-top: 5px;
  border-radius: 100%;
  background-color: white;
}

.iconos {
  width: 2rem;
  height: 2rem;
  color: #46cfff;
}

.iconos-texto {
  margin: 0;
  padding: 0;
  color: #1681A3;
}

.contenedor-contenido {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  padding: 50px;
  padding-top: 120px;
  width: 100%;
  height: 100%;
}

.texto-titulo {
  font-weight: bold;
  font-size: 1.4rem;
  text-transform: uppercase;
}

.logo-documento {
  width: 9rem;
  position: absolute;
  right: 0;
}

.texto {
  padding-top: 1rem;
}

.nombre-firma {
  border-top: 1px solid black;
  width: fit-content;
  padding-top: 1rem;
}


.dots::after {
  content: '';
  display: inline-block;
  width: 1ch;
  animation: dots 1s steps(3, end) infinite;
}

@keyframes dots {
  0% { content: ''; }
  33% { content: '.'; }
  66% { content: '..'; }
  100% { content: '.'; }
}

</style>
